<template>
	<v-card class="elevation-0" >
		<v-row>

			<!-- Alerta de que debe seleccionar una persona primero -->
			<v-alert
	      border="bottom"
	      type="info"
	      text
	      dark
	    >
	      Selecciona primero un hermano y a continuación, el sistema arrojara los datos de los demás hermanos
	    </v-alert>
			<br/>

			<v-col cols="12">
				<v-card class="shadowCard" >
		      <v-card-title>
		        Selecciona un hermano
		      </v-card-title>
		      <v-card-text>
			  	<!-- BUSCAR POR MATRICULA -->
			  	<label class="pl-0 black--text">Alumno</label>
			  	<div class="text-caption grey--text">Escribe al menos 3 letras o la matrícula para buscar hermanos.</div>
					<v-row>
						<v-col cols="12" class="pt-0">
							<v-tooltip bottom color="blue" max-width="300">
								<template v-slot:activator="{ on, attrs }">
									<v-autocomplete
					          filled 
					          dense
					          clearable
					          no-filter
					          v-model="alumnoSeleccionado"
					          :items="itemsAlumnosAutocomplete"
					          :loading="loadingAlumnos"
					          :search-input.sync="alumnoSearchInput"
					          label="Buscar alumno"
					          hide-details
					          return-object
					          item-text="datos_completos"
					          item-value="id_alumno"
					          class="mt-4"
					          placeholder="Ej. nombre o matrícula"
					          v-bind="attrs"
					          v-on="on"
					        >
					        </v-autocomplete>
								</template>
								<span>Selecciona un hermano para cargar los datos de todos sus hermanos</span>
							</v-tooltip>
						</v-col>
					</v-row>
		      </v-card-text>
		    </v-card>
			</v-col>
		</v-row>

		<v-row>
			<v-col cols="12">
				<v-expansion-panels>
					<v-expansion-panel
			      v-for="(item, i ) in hermanos"
			      :key="i"
			      class="elevation-10"
			    >
			      <v-expansion-panel-header>
			        Datos del hermano {{ i + 1 }}
			      </v-expansion-panel-header>
			      <v-expansion-panel-content>
					    <!-- Datos generales del alumno -->
					    <label class="pl-0 black--text" >Datos generales</label>
							<v-row >
								<v-col cols="12" sm="6">
									<v-text-field
									  filled 
									  dense
									  hide-details
									  v-model="item.nombre"
									  readonly
									  label="Nombre"
									></v-text-field>
								</v-col>

								<v-col cols="12" sm="6">
									<v-text-field
									  filled 
									  dense
									  hide-details
									  v-model="item.apellido_paterno"
									  readonly
									  label="Ap. Paterno"
									></v-text-field>
								</v-col>

								<v-col cols="12" sm="6">
									<v-text-field
									  filled 
									  dense
									  hide-details
									  v-model="item.apellido_materno"
									  readonly
									  label="Ap. Materno"
									></v-text-field>
								</v-col>

								<v-col cols="12" sm="6">
									<v-text-field
									  filled 
									  dense
									  hide-details
									  v-model="item.edad"
									  readonly
									  label="Edad"
									  type="number"
									></v-text-field>
								</v-col>
							</v-row>

							<!-- Datos del contacto -->
							<v-divider class="my-4"></v-divider>
							<label class="pl-0 black--text" >Datos de contacto</label>
							<v-row>
								<v-col cols="12" sm="6">
									<v-text-field
									  filled 
									  dense
									  hide-details
									  v-model="item.telefono"
									  readonly
									  label="Teléfono"
									  type="number"
									></v-text-field>
								</v-col>

								<v-col cols="12" sm="6">
									<v-text-field
									  filled 
									  dense
									  hide-details
									  v-model="item.celular"
									  readonly
									  label="Celular"
									  type="number"
									></v-text-field>
								</v-col>
							</v-row>
			      </v-expansion-panel-content>
			    </v-expansion-panel>
			  </v-expansion-panels>
			</v-col>
		</v-row>

		<v-card-actions>
      <v-tooltip bottom color="blue" max-width="300">
        <template v-slot:activator="{ on, attrs }">
          <v-btn 
          	text 
          	@click="dialogAddAlumno.estatus = false"
          	v-bind="attrs"
          	v-on="on"
          >
            Cancelar
          </v-btn>
        </template>
        <span>Cerrar y cancelar el proceso de reinscripción</span>
      </v-tooltip>

      <!-- <v-btn 
      	text 
        @click="steppers.paso = 1"
      >
        Regresar
      </v-btn> -->

      <v-spacer></v-spacer>
      <v-tooltip bottom color="blue" max-width="300" v-if="hermanos.length">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
          	tile
            color="primary"
            @click="steppers.paso = 2"
            v-bind="attrs"
            v-on="on"
          >
            Siguiente
          	<v-icon right small>mdi-arrow-right</v-icon>
          </v-btn>
        </template>
        <span>Continuar al siguiente paso para seleccionar grupo</span>
      </v-tooltip>
  	</v-card-actions>


  	<!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>


	</v-card>
</template>
<script>
import axios from 'axios';
	import { mapGetters, mapActions } from 'vuex'
  import Alerta          from '@/components/alertas/Alerta.vue'
  import carga           from '@/components/alertas/carga.vue';

  import validarErrores  from '@/mixins/validarErrores'

	// Componentes
  export default {
  	components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores ],

  	props:[
			'grupo',
			'alumno',
			'steppers',
			'hermanos',
			'tutor',
			'dialogAddAlumno',
	  ],

    data: () => ({
    	escuela: 2,
			// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      cantidadHermanos: 1,

      respuestaAlerta:false,
      cargar: false,

			step:1,
			isTutor:true,

			opcion:1,

			posicionHermano: 0,

			empleados:[],
			sonHermanos:false,
			existeMatricula: false,
    	prospectos:[],
    	parametrosProspectos:{
    		estatus: false
    	},
    	existeProspecto:false,
    	prospecto: null,
    	alumnoSeleccionado: null,
    	alumnosBusqueda: [],
    	alumnoElegido: null,
    	alumnoSearchInput: '',
    	loadingAlumnos: false,
    	_debounceAlumnos: null,

    	alertaSeguridad: false,

    	headers:[
    		{ text: 'Nombre'       , value: 'nombre'       },
        { text: 'Telefono'     , value: 'telefono'     },
        { text: 'Grupo'        , value: 'grupo'        },
        { text: 'ID prospecto' , value: 'id_prospecto' },
    	],


    }),

    computed: {
    	...mapGetters('login',['getdatosUsuarioERPERP', 'getEscuela']),

    	itemsAlumnosAutocomplete () {
    		const list = [...this.alumnosBusqueda]
    		if (
    			this.alumnoElegido &&
    			!list.some(a => a.id_alumno === this.alumnoElegido.id_alumno)
    		) {
    			list.unshift(this.alumnoElegido)
    		}
    		return list
    	},
    },

    watch:{
    	alumnoSeleccionado( value){

    		if( value ){
    			this.alumnoElegido = { ...value }
    			this.hermanos.splice(0)
    			this.getHermanos( value )
    		}
    	},

    	alumnoSearchInput (val) {
    		if (this._debounceAlumnos) clearTimeout(this._debounceAlumnos)
    		this._debounceAlumnos = setTimeout(() => {
    			this.buscarAlumnosRemoto(val)
    		}, 400)
    	},
    },

    beforeDestroy () {
    	if (this._debounceAlumnos) clearTimeout(this._debounceAlumnos)
    },

    created () {
    	this.escuela = this.getEscuela
    	this.alumno.unidad_negocio = this.getEscuela
    },

    methods: {
    	debeBuscarAlumnos (q) {
    		const t = (q || '').trim()
    		if (!t) return false
    		if (/^\d+$/.test(t)) return t.length >= 1
    		return t.length >= 3
    	},

    	buscarAlumnosRemoto (q) {
    		const termino = (q || '').trim()
    		if (!this.debeBuscarAlumnos(termino)) {
    			this.alumnosBusqueda = []
    			this.loadingAlumnos = false
    			return
    		}

    		this.loadingAlumnos = true
    		const params = {
    			buscar: termino,
    			limit: 50,
    			solo_hermanos: 1,
    		}

    		return this.$http.get('inscripciones.alumnos.busqueda', { params }).then(response => {
    			this.alumnosBusqueda = Array.isArray(response.data) ? response.data : []
    		}).catch(error => {
    			this.validarError(
    				error.response && error.response.data
    					? error.response.data.message
    					: 'Error al buscar alumnos'
    			)
    			this.alumnosBusqueda = []
    		}).finally(() => {
    			this.loadingAlumnos = false
    		})
    	},

      abrirDialogProspecto( ){
      	this.existeProspecto              = true
      	this.parametrosProspectos.estatus = true
      },

      getHermanos( value ){
        this.cargar = true
        return this.$http.post('inscripciones.hermanos' , value ).then(response=>{
        	this.cargar = false
        	console.log( response.data )

        	let hermanos = response.data 

        	for( const i in hermanos ){

        		this.hermanos.push( hermanos[i] )

        	}


        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

      },

    },
  }
</script>
